import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function matchesGlob(pattern: string, path: string): boolean {
  const regex = new RegExp(
    "^" +
      pattern
        .replace(/\[[^\]]+\]/g, "\x00")
        .replace(/[.+^${}()|[\]\\]/g, "\\$&")
        .replace(/\x00/g, "[^/]+")
        .replace(/\?/g, ".") +
      "$",
  );
  return regex.test(path);
}

export function buildUrl(url: string, params: Record<string, string>): string {
  return Object.entries(params).reduce(
    (url, [key, value]) => url.replace(`[${key}]`, value),
    url,
  );
}

/** 価格を日本円形式にフォーマットする（例: ¥ 1,000） */
export function formatPrice(value: number): string {
  return `¥ ${value.toLocaleString("ja-JP")}`;
}
